import * as angular from 'angular';
import { NetworkPointResource } from 'app/_resources/network-point.resource';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpMapLazyPin
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * This is a listener to load info windows of ngMap pins lazily.
     * It watches the attribute `pkpMapLazyPin` and lazy loads on change of that evaluated expression.
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpMapLazyPin', pkpMapLazyPin);

    function pkpMapLazyPin(NetworkPoint: NetworkPointResource) {
        return {
            restrict: 'A',
            scope: false,
            link: linkFn
        };

        function linkFn(scope, elem, attr) {
            scope.uiLoading = true;
            scope.uiLoadingError = false;

            scope.$watch(
                function () {
                    var pkpMapLazyPin = scope.$eval(attr.pkpMapLazyPin);
                    if (pkpMapLazyPin) {
                        return pkpMapLazyPin;
                    }
                },
                function (newPkpMapLazyPin, oldPkpMapLazyPin) {
                    if (
                        !newPkpMapLazyPin ||
                        angular.equals(newPkpMapLazyPin, oldPkpMapLazyPin)
                    ) {
                        return;
                    }

                    onLazyLoad();
                },
                true
            );

            function onLazyLoad() {
                var param = scope.$eval(attr.pkpMapLazyPin);
                scope.showInfoWindow(param.e, param.elemId, param.e.latLng);

                if (scope.nwp.identifier) {
                    return; // NWP has already been loaded.
                }

                scope.uiLoading = true;

                NetworkPoint.get(
                    { id: scope.nwp.id },
                    function (res) {
                        scope.nwp = res;
                        scope.uiLoadingError = false;
                    },
                    function () {
                        scope.uiLoadingError = true;
                    }
                ).$promise.finally(function () {
                    scope.uiLoading = false;
                });
            }
        }
    }
})();
